import {type ComponentType} from 'react'

import {type ThemePlayerProps, type ThemePlugin} from '#/types/capsule'
import {EditorComponent} from './EditorComponent'
import {exerciseTypes} from './exerciseTypes'
import {PlayerComponent} from './PlayerComponent'
import {settingsSchema} from './settingsSchema'
// SkiaPlayerComponent is a future enhancement — requires @shopify/react-native-skia to be installed.
// Import it here when the package is available: import {SkiaPlayerComponent} from './SkiaPlayerComponent'

const classicQuizTheme: ThemePlugin = {
  id: 'classic-quiz',
  name: 'Classic Quiz',
  version: '1.0.0',
  description: 'Multiple choice and True/False questions with instant feedback',
  previewColor: '#6c5ce7',
  category: 'classic' as const,
  exerciseTypes,
  settingsSchema,
  PlayerComponent: PlayerComponent as ComponentType<ThemePlayerProps>,
  EditorComponent,
  PreviewComponent: PlayerComponent as ComponentType<ThemePlayerProps>,
}

export default classicQuizTheme
